import { useEffect } from "react";
import { News } from "@/models/database/news/News.model";
import {
  collectionDoc,
  collectionRef,
} from "@/api/collectionRef/collectionOperations";
import { useNewsStore } from "@/store/news/news.store";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export const useTenantNews = () => {
  const { news, loading, error, setNews, setLoading, setError } =
    useNewsStore();

  const fetchNews = async () => {
    try {
      setLoading(true);
      const newsArray: News[] = [];

      const ref = collectionRef.news(brand.tenantId);
      const query = await ref.get();

      // Get news from Firestore
      query.docs.map(async (doc) => {
        newsArray.push(doc.data() as News);
        return doc.data() as News;
      });

      // Get unique creators
      const uniqueCreators = Array.from(
        new Set(newsArray.map((news) => news.createdBy))
      );

      // Get profiles for unique creators from Firestore
      const profileDocs = await Promise.all(
        uniqueCreators.map(async (creator) => {
          const profileDoc = await collectionDoc.profiles(
            creator,
            brand.tenantId
          );
          return profileDoc.data();
        })
      );

      // Assign profile to news
      newsArray.forEach((news) => {
        const profile = profileDocs.find(
          (profile) => profile.uid === news.createdBy
        );
        news.author = {
          fullName: profile?.fullName,
          profileLogoUrl: profile?.profileLogoUrl,
          slug: profile?.slug,
          uid: profile?.uid,
          userName: profile?.userName,
        };
      });

      setNews(newsArray);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!news) {
      fetchNews();
    }
  }, [brand.tenantId]);

  return {
    data: news,
    loading,
    error,
  };
};
